var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 43.2c10.604 0 19.2-8.596 19.2-19.2S34.604 4.8 24 4.8 4.8 13.396 4.8 24 13.396 43.2 24 43.2ZM22.93 17.203A2.4 2.4 0 0 0 19.2 19.2v9.6a2.4 2.4 0 0 0 3.731 1.997l7.2-4.8a2.4 2.4 0 0 0 0-3.994l-7.2-4.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.52831aafcf6208267288081d10631979.svg";
export { ForwardRef as ReactComponent };